module.exports = "0.36.0";



//////////////////
// WEBPACK FOOTER
// ./~/autocomplete.js/version.js
// module id = 619
// module chunks = 0